export default {
  root: {
    width: '363px',
  },
}
